import React, { useState, useEffect } from 'react';
import { InputMask } from '@react-input/mask';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const GestoraModal = ({ gestora, onClose, onGestoraAtualizada }) => {
  const [tituloModal, setTituloModal] = useState("");
  
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    cnpj: '',
    inscricao_municipal: '',
    inscricao_estadual: '',
    cep: '',
    estado: '',
    cidade: '',
    bairro: '',
    rua: '',
    numero: '',
    complemento: '',
    ativo: true
  });

  useEffect(() => {
    if (gestora != null) {
      setFormData({
        ...gestora,
        cnpj: gestora.cnpj || '',
        numero: gestora.numero || ''
      });
      setTituloModal('Editar Gestora');
    } else {
      setTituloModal('Nova Gestora');
    }
  }, [gestora]);

  const estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
    'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : name === 'ativo' ? value === 'true' : value
    });
  };

  const buscarEndereco = async () => {
    if (formData.cep && formData.cep.length === 9) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${formData.cep.replace('-', '')}/json/`);
        const data = await response.json();

        if (!data.erro) {
          setFormData(prev => ({
            ...prev,
            rua: data.logradouro || '',
            bairro: data.bairro || '',
            cidade: data.localidade || '',
            estado: data.uf || ''
          }));
        }
      } catch (error) {
        throw error;
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Carregando...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const dataToSubmit = {
        ...formData,
        nome: formData.nome.toUpperCase(),
        numero: formData.numero ? parseFloat(formData.numero) : null
      };

      if (gestora) {
        await api.put(`/gestoras/${gestora.id}`, dataToSubmit);
        Swal.fire('Sucesso', 'Gestora atualizada com sucesso!', 'success');
      } else {
        await api.post('/gestoras', dataToSubmit);
        Swal.fire('Sucesso', 'Gestora criada com sucesso!', 'success');
      }

      onGestoraAtualizada();
      onClose();
    } catch (error) {
      Swal.fire('Erro', error.response.data.message || 'Erro ao salvar gestora', 'error');
    } finally {
      Swal.close();
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="fw-bold mt-2">{tituloModal}</h4>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-8">
                  <label className="form-label fw-bold">Nome da Gestora</label>
                  <input
                    type="text"
                    name="nome"
                    value={formData.nome.toUpperCase()}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                    required
                  />
                </div>
                <div className="col-lg-4 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">Status</label>
                  <select
                    name="ativo"
                    value={formData.ativo}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value={true}>Ativo</option>
                    <option value={false}>Inativo</option>
                  </select>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-4">
                  <label className="form-label fw-bold">Telefone</label>
                  <InputMask
                    mask="(__) _____-____"
                    replacement={{ _: /\d/ }}
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="(XX) XXXXX-XXXX"
                  />
                </div>
                <div className="col-lg-4 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">E-mail</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                <div className="col-lg-4 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">CNPJ</label>
                  <InputMask
                    mask="__.___.___/____-__"
                    replacement={{ _: /\d/ }}
                    name="cnpj"
                    value={formData.cnpj}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-6">
                  <label className="form-label fw-bold">Inscrição Municipal</label>
                  <input
                    type="text"
                    name="inscricao_municipal"
                    value={formData.inscricao_municipal}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                <div className="col-lg-6 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">Inscrição Estadual</label>
                  <input
                    type="text"
                    name="inscricao_estadual"
                    value={formData.inscricao_estadual}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <h6 className="fw-bold">Endereço</h6>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-3">
                  <label className="form-label fw-bold">CEP</label>
                  <InputMask
                    mask="_____-___"
                    replacement={{ _: /\d/ }}
                    name="cep"
                    value={formData.cep}
                    onChange={handleChange}
                    onBlur={buscarEndereco}
                    className="form-control"
                  />
                </div>
                <div className="col-lg-6 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">Rua</label>
                  <input
                    type="text"
                    name="rua"
                    value={formData.rua}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                <div className="col-lg-3 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">Número</label>
                  <input
                    type="number"
                    name="numero"
                    value={formData.numero}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-4">
                  <label className="form-label fw-bold">Bairro</label>
                  <input
                    type="text"
                    name="bairro"
                    value={formData.bairro}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                <div className="col-lg-4 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">Cidade</label>
                  <input
                    type="text"
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
                <div className="col-lg-4 mt-lg-0 mt-3">
                  <label className="form-label fw-bold">Estado</label>
                  <select
                    name="estado"
                    value={formData.estado}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Selecione o estado</option>
                    {estados.map((estado) => (
                      <option key={estado} value={estado}>
                        {estado}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12">
                  <label className="form-label fw-bold">Complemento</label>
                  <input
                    type="text"
                    name="complemento"
                    value={formData.complemento}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer mt-4">
              <div className="row">
                <div className="col-12 text-end">
                  <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                    <FaTimes /> Fechar
                  </button>
                  <button className="btn btn-custom-primary ms-3" type="submit">
                    <FaRegSave /> Salvar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GestoraModal; 